import * as Mod1 from "./discourse/admin-community-media-plugin-route-map";
import * as Mod2 from "./discourse/components/community-media-gallery";
import * as Mod3 from "./discourse/components/community-media-user-display-name";
import * as Mod4 from "./discourse/initializers/community-media";
const compatModules = {
  "discourse/admin-community-media-plugin-route-map": Mod1,
  "discourse/components/community-media-gallery": Mod2,
  "discourse/components/community-media-user-display-name": Mod3,
  "discourse/initializers/community-media": Mod4,
};
export default compatModules;
